import { useForm } from "react-hook-form";
import emailjs from "emailjs-com";
import {
  JoinForm,
  EmailInput,
  CTAButton,
  ErrorTag,
  JoinFlexContainer,
} from "./JoinNowElements";
import { ErrorMessage } from "@hookform/error-message";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const JoinNowForm = () => {
  const {
    register,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });
  const notify = () => toast("Email received. Thank you.😊");
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ppq378n",
        "template_fjq9ahd",
        e.target,
        "user_aVlquSWCuokyHQz747vXo"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    reset();
  };

  return (
    <JoinForm onSubmit={sendEmail}>
      <JoinFlexContainer>
        <EmailInput
          type="email"
          name="email"
          placeholder="Enter email address"
          {...register("email", {
            required: "Please fill in your email",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          })}
        />
        <CTAButton disabled={!isValid} onClick={notify}>
          Join
        </CTAButton>
        <ToastContainer position="top-center" hideProgressBar />
      </JoinFlexContainer>
      <ErrorTag>
        <ErrorMessage errors={errors} name="email" />
      </ErrorTag>
    </JoinForm>
  );
};

export default JoinNowForm;
